export default __webpack_public_path__ + "static/media/6.c3456f21.jpg";